import Vue from 'vue'

const client = Vue.prototype.$api

export const OPENLEGAL_PROMOTION_NEWSLETTER_TYPE = 'OPENLEGAL_PROMOTION'

export default {
    sendCompaniesContactForm (form) {
        return client.post('/mk/companies-contact-form', form)
    },
		subscribePromotionOpenlegal (email) {
			return client.post('/mk/newsletter-registrations', {
				email,
				type: OPENLEGAL_PROMOTION_NEWSLETTER_TYPE
			})
		}
}



// WEBPACK FOOTER //
// ./src/repositories/MarketingRepository.js